import React,{useContext,useState,useEffect} from "react";
import {Box,Typography,Button} from '@mui/material';
import "../../cssfiles/homepage.css";
import { ThemeContext } from "../Homepage";
import CustomToast from "../CommonComponents/CustomToast";
import CustomTooltip from "../CommonComponents/CustomTooltip";
import LK_Loading from "../../images/LK_Loading.gif"
import LK_Search from '../../images/LK_Search';
import LK_Add from "../../images/LK_Add";
import LK_Delete from '../../images/LK_Delete';
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import LK_Close from '../../images/LK_Close';
import Divider from '@mui/material/Divider';
import LK_Edit from "../../images/LK_Edit"; 
import LK_ArrowDown from '../../images/LK_ArrowDown';
import LK_ArrowRight from '../../images/LK_ArrowRight';
import {getDevicesTypes, saveDeviceTypes, saveDeviceTypeProjects, deleteDeviceType} from "../../Restclient/datacollection"
import { useSelector } from "react-redux";
import {  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import LK_Menu from "../../images/LK_Menu";
import { CommentsDisabledOutlined } from "@mui/icons-material";

function TableRow(props){

    const{ theme }= useContext(ThemeContext);
    const [isExpanded,setisExpanded] = React.useState([]);
    const [isEdit,setisEdit] = React.useState([[],[]]);
    const [info,setInfo] = React.useState({id:"",key:"",name:"",description:"",operation:"",user:"",projectlist:[]});
    const [required,setRequired] = React.useState(0);
    const [disableButtons,setDisableButtons] = React.useState(0); //All enabled by default, 1 for save disabled, 2 for cancel disabled

    useEffect(()=>{
      if(props.editKey.key!=='' ){
        if(props.editKey.level===props.level){
            props.handleDisable(2)
            setisEdit([[...isEdit[0],props.data.length-1],[...isEdit[1],props.editKey.key]])
            setInfo({...info,id:props.data[props.data.length-1].id,key:props.data[props.data.length-1].key, name:props.data[props.data.length-1].name, description:props.data[props.data.length-1].description, operation:props.data[props.data.length-1].operation,user:props.data[props.data.length-1].user, projectlist:props.data[props.data.length-1].projectlist? props.data[props.data.length-1].projectlist:[]});
        }
      }
    },[props.editKey,props.level])

    function handleExpand(e){
        setisExpanded([...isExpanded,parseInt(e.currentTarget.id,10)])
    }

    function handleCollapse(e){
        const temp = isExpanded.filter(value => value !== parseInt(e.currentTarget.id,10));
        setisExpanded([...temp])
    }

    function handleEdit(e){
        props.handleDisable(2)
        setisEdit([[...isEdit[0],parseInt(e.currentTarget.id,10)],[...isEdit[1],props.data[e.currentTarget.id].key]])
        setInfo({...info,id:props.data[e.currentTarget.id].id,key:props.data[e.currentTarget.id].key, name:props.data[e.currentTarget.id].name, description:props.data[e.currentTarget.id].description, operation:props.data[e.currentTarget.id].operation ,user:props.data[e.currentTarget.id].user, projectlist:props.data[e.currentTarget.id].projectlist? props.data[e.currentTarget.id].projectlist:[]});
    }

    function handleEditCancel(e){
        setisEdit([[],[]])
        props.editCancel(info)
        setInfo({id:"",key:"",name:"",description:"", operation:"",user:"",projectlist:[]});
        props.handleDisable(0)

    }

    function validatename(name,id){
        let same = 0;
        if(name ==="" || name===undefined || name===null){
            same = 1;
        }else{
            // let newname = props.data[i].name
            for (let i = 0; i < props.data.length; i++) {
                let newname = props.data[i].name
                if(props.data[i].name.charAt(0)==='_'){
                    newname = props.data[i].name.substring(1);
                }
                if(newname===name && i.toString()!==id){
                    same = 2;
                }
            }
        }
        return same;
    }

    function handleEditSave(e){
        let validation = validatename(info.name,e.target.id)
        if(validation === 0){
            setisEdit([[],[]])
            props.handleSave(info)
            setInfo({id:"",key:"",name:"",description:"",operation:"",user:"",projectlist:[]});
            setRequired(0)
            props.handleDisable(0)
        }else{
            if(validation === 1){
                setRequired(1)
            }else{
                setRequired(2)
            }
            // setRequired(2)
            // setDisableButtons(0)

        }
    }

    function handleProjectList(e){
        // setprojectlist(1)
        props.handleProjectList(props.data[e.currentTarget.id],{level:props.level,index:e.currentTarget.id})
    }

    function handleChange(value,e){
        let temp = {...info}
        temp[e.target.id]=value
        setInfo(temp)
    }

    function handleAddSubType(e){
        // setisEdit([[...isEdit[0]],[...isEdit[1],[e.currentTarget.id].key]])
        setisExpanded([...isExpanded,parseInt(e.currentTarget.id,10)])
        props.addSubType(e.currentTarget.id,props.level,props.data[e.currentTarget.id].id)
    }

    function handleCheck(selected,e){
        // // setisEdit([[...isEdit[0]],[...isEdit[1],[e.currentTarget.id].key]])
        // setisExpanded([...isExpanded,parseInt(e.currentTarget.id,10)])
        props.handleCheck(selected,e,props.level)
    }

    
    function handlename(name){
            const newname = name.substring(1);
        // // setisEdit([[...isEdit[0]],[...isEdit[1],[e.currentTarget.id].key]])
        // setisExpanded([...isExpanded,parseInt(e.currentTarget.id,10)])
        // props.handleCheck(selected,e,props.level)
        return newname
    }       
    

    return(
        <>
            {props.data.map((data,index) => (
                <>
                    <CustomDialogBox dialogTitle={"Required fields not filled"} dialogText={"Required fields to must be filled"} openDialog={required===1} handleCloseDialog={()=>setRequired(0)} handleConfirmDialog={()=>setRequired(0)} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                    <CustomDialogBox dialogTitle={"Name already in use"} dialogText={"Name is already in use"} openDialog={required===2} handleCloseDialog={()=>setRequired(0)} handleConfirmDialog={()=>setRequired(0)} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                    <Box sx={{height:'8%',width:'100%',backgroundColor:"none",boxSizing:"border-box",alignContent:"center",justifyContent: 'center', display:'flex',flexDirection:'row'}}>
                        {/* <Box sx={{height:'100%',boxSizing:"border-box",padding:"8px", display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <CustomCheckbox id={data.key} checked={props.checkList.includes(data.key)?true:false} onChange={handleCheck} width={15} height={15}/>
                        </Box> */}
                        {props.columns.map((column,cindex) => (
                            <Box sx={{height:'100%',width:column.width?column.width:'auto',backgroundColor:"none",boxSizing:"border-box",padding:"8px",alignContent:"center",alignItems:"center",display:'flex',flexDirection:'row'}}>
                                {cindex===0?
                                    <>
                                        <CustomTooltip title={"Standard Types and Subtypes cannot be selected"} disableHoverListenerForTooltip={(props.disabled!==0 && props.disabled!==1) || (column.dataIndex==='name' && data[column.dataIndex].charAt(0)==='_')?false:true} offset={[30,-20]} placement={'right-end'}>
                                            <Box sx={{height:'100%',boxSizing:"border-box",padding:"8px",paddingLeft:`calc(${props.level}*24px)`, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                    <CustomCheckbox id={data.key} checked={(props.level===0?(props.checkList[0].includes(data.key)):(props.checkList[1].includes(data.key)))?true:false} disabled={(props.disabled!==0 && props.disabled!==1) || (column.dataIndex==='name' && data[column.dataIndex].charAt(0)==='_')?true:false} onChange={handleCheck} width={15} height={15}/>
                                            </Box>
                                        </CustomTooltip>

                                    </>
                                    :<></>
                                }
                                {data.children && data.children.length!==0 && column.dataIndex==='name'?
                                    <>
                                        {isExpanded.includes(index)?
                                            <Button id={index} onClick={handleCollapse} disabled={(props.disableButtons!==0 && props.disableButtons!==1)?true:false} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'20px',width:'20px',minWidth:'20px',boxSizing:'border-box', fontWeight: 400,alignSelf:"center",marginLeft:"-2px",marginRight:"0",marginTop:'0px'}}><LK_ArrowDown color={(props.disableButtons!==0 && props.disableButtons!==1)?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"10px"} height={"10px"}/></Button>
                                            :
                                            <Button id={index} onClick={handleExpand} disabled={(props.disableButtons!==0 && props.disableButtons!==1)?true:false} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'20px',width:'20px',minWidth:'20px',boxSizing:'border-box', fontWeight: 400,alignSelf:"center",marginLeft:"-2x",marginRight:"0",marginTop:'-0.5px'}}><LK_ArrowRight color={(props.disableButtons!==0 && props.disableButtons!==1)?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"10px"} height={"10px"}/></Button>
                                        }
                                    </>
                                    :
                                    <>
                                    </>
                                }
                                {/* {props.level!==0 && column.dataIndex==='name'?
                                    <Box sx={{display:'flex',flexDirection:'row',width:'32px',height:'100%',BoxSizing:"border-box"}}>
                                    </Box>
                                    :
                                    <>
                                    </>
                                } */}
                                {column.dataIndex!=='operation'?
                                    <>
                                        {isEdit[0].includes(index) && isEdit[1].includes(data.key)?
                                            <>
                                                <CustomTextField id={column.dataIndex}  onChange={handleChange} defaultValue={data[column.dataIndex]} maxLength={250} width={'100%'} permittedCharacters={column.dataIndex==='name'?'^[a-zA-Z][a-zA-Z0-9_]*$':null} errorText={"Only alphanumeric and '_' characters are allowed"}/>
                                                {column.required===true?<span style={{ color: "red", marginLeft: "5px" }}>*</span>:<></>}
                                            </>
                                        :
                                            <Typography style={{ lineHeight: "24px" }} sx={{textAlign:'left',alignContent:'end', color:'var(--PrimaryText)',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{column.dataIndex==='name' && data[column.dataIndex].charAt(0)==='_'?handlename(data[column.dataIndex]):data[column.dataIndex]}</Typography>                                    
                                        }
                                    </>
                                        :
                                    <>
                                                {data[column.dataIndex] && isEdit[1].includes(data.key)!==true?
                                                    <>
                                                        {data[column.dataIndex]==='type'?
                                                            <Box sx={{display:'flex',flexDirection:"row",gap:"20px"}}>
                                                                <CustomTooltip title={"Edit"} offset={[30,-20]} placement={'right-end'}>
                                                                    <Button id={index} onClick={handleEdit} disabled={(props.disabled===2 || props.disabled===1) || (data['name'].charAt(0)==='_')?true:false} sx={{minWidth:'20px','& .MuiButtonBase-root.MuiButton-root':{width:'20px'},padding:0}} style={{ fontSize: '12px',boxSizing:'border-box', fontWeight: 400,alignSelf:"center",marginLeft:"0px",justifyContent:"start",}}><LK_Edit color={((props.disabled===2 || props.disabled===1) || (data['name'].charAt(0)==='_'))?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"20px"} height={"20px"}/></Button>
                                                                </CustomTooltip>
                                                                <CustomTooltip title={"Add Subtype"} offset={[30,-20]} placement={'right-end'}>
                                                                    <Button id={index} onClick={handleAddSubType} disabled={(props.disabled===2 || props.disabled===1)?true:false} sx={{minWidth:'20px','& .MuiButtonBase-root.MuiButton-root':{width:'20px'},padding:0}} style={{ fontSize: '12px',boxSizing:'border-box', fontWeight: 400,alignSelf:"center",marginLeft:"0px"}}><LK_Add color={((props.disabled===2 || props.disabled===1))?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"20px"} height={"20px"}/></Button>
                                                                </CustomTooltip>
                                                                <CustomTooltip title={"Project list"} offset={[30,-20]} placement={'right-end'}>
                                                                    <Button id={index} onClick={handleProjectList} disabled={(props.disabled===2 || props.disabled===1) || (data['name'].charAt(0)==='_')?true:false} sx={{minWidth:'20px','& .MuiButtonBase-root.MuiButton-root':{width:'20px'},padding:0}} style={{ fontSize: '12px',boxSizing:'border-box', fontWeight: 400,alignSelf:"center",marginLeft:"0px"}}><LK_Menu color={((props.disabled===2 || props.disabled===1) || (data['name'].charAt(0)==='_'))?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"20px"} height={"20px"}/></Button>
                                                                </CustomTooltip>
                                                            </Box>
                                                            :
                                                            <Box sx={{display:'flex',flexDirection:"row",gap:"20px"}}>
                                                                <CustomTooltip title={"Edit"} offset={[30,-20]} placement={'right-end'}>
                                                                    <Button id={index}  value={"0"} onClick={handleEdit} disabled={(props.disabled===2 || props.disabled===1) || (data['name'].charAt(0)==='_')?true:false} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'20px',width:'20px',minWidth:'20px',boxSizing:'border-box', fontWeight: 400,alignSelf:"center",marginLeft:"0px",marginRight:"0",marginTop:'-8px'}}><LK_Edit color={((props.disabled===2 || props.disabled===1) || (data['name'].charAt(0)==='_'))?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"20px"} height={"20px"}/></Button>
                                                                </CustomTooltip>
                                                                <CustomTooltip title={"Project list"} offset={[30,-20]} placement={'right-end'}>
                                                                    <Button id={index} onClick={handleProjectList} disabled={(props.disabled===2 || props.disabled===1) || (data['name'].charAt(0)==='_')?true:false} sx={{minWidth:'20px','& .MuiButtonBase-root.MuiButton-root':{width:'20px'},padding:0}} style={{ fontSize: '12px',boxSizing:'border-box', fontWeight: 400,alignSelf:"center",marginLeft:"0px"}}><LK_Menu color={((props.disabled===2 || props.disabled===1) || (data['name'].charAt(0)==='_'))?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"20px"} height={"20px"}/></Button>
                                                                </CustomTooltip>
                                                            </Box>
                                                        }
                                                    </>
                                                    :
                                                    <Box sx={{display:'flex',flexDirection:'row',gap:'4px',width:'100%',height:'100%',BoxSizing:"border-box"}}>
                                                        <Button id={index} onClick={handleEditSave} disabled={false} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0,minWidth:'16px'}} style={{ fontSize: '12px',boxSizing:'border-box', fontWeight: 400,alignSelf:"center",justifyContent:'start'}}>Save</Button>
                                                        <Button id={index} onClick={handleEditCancel} disabled={false} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0,minWidth:'16px'}} style={{ fontSize: '12px',boxSizing:'border-box', fontWeight: 400,alignSelf:"center"}}>Cancel</Button>
                                                    </Box>
                                                }
                                    </>
                                }
                            </Box>
                        ))}
                    </Box>
                    {/* {props.level===0 && index===props.data.length-1? <></> : <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>} */}
                    <Divider variant="middle" style={{margin:"0px 2px 0px 2px", width:`calc(100% - (4px + (${props.level}*24px)))`,background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                    {isExpanded.includes(index)?
                        <>
                            <TableRow width={"100%"} data={data.children} columns={props.columns} disableButtons={props.disableButtons} handleCheck={props.handleCheck} editKey={props.editKey} editCancel={props.editCancel} handleSave={props.handleSave} level={props.level+1} checkList={props.checkList} handleDisable={props.handleDisable} disabled={props.disabled} handleProjectList={props.handleProjectList}/>
                        </>
                        :
                        <></>
                    }
                </>
            ))} 
        </>
    )
}

function ProjectForm({openDialog, handleCloseDialog, handleConfirmDialog, data, selectedoption ,align, level , name}){

    const [info,setInfo] = React.useState({id:"",key:"",name:"",description:"",operation:"",user:"",projectlist:[]});
    const [parentId,setparentId] = React.useState(0);
    const [projectlist ,setprojectlist ] = React.useState([]);

    const theme = useSelector((state) => state.themedata.theme);
    const userdetails = useSelector(state => state.logindata.userdetails);
    const projectname = useSelector(state => state.mainpagedata.selectedprojectname)

    useEffect(()=>{
        setprojectlist(selectedoption)
    },[selectedoption])

    function handleCheck(checked,e,level){
        if(checked){
            if(e.currentTarget.id==='all'){
                setprojectlist([e.currentTarget.id,...projectlist])
                }else{
                setprojectlist([...projectlist, e.currentTarget.id])
                }
        }else{
            if(e.currentTarget.id==='all'){
                setprojectlist([])
                }else{
                setprojectlist([...projectlist.filter(value => value !== e.currentTarget.id)])
                }
        }
    }

    function handleSave(){
        handleConfirmDialog(projectlist)
        setprojectlist([])
    }

    function handleClose(){
        handleCloseDialog()
        setprojectlist([])
    }

    return(
        <>
           <Dialog
                open={openDialog}
                onClose={handleClose}
                BackdropProps={{ 
                    sx:{
                        backgroundColor: (theme === 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                    }
                }}
                sx={{ "& .MuiDialog-paper": { borderRadius:"0px",  backgroundColor:(theme === 'light')?"#FFFFFF":"#19191B",alignContent:"center"} }}
            >
                <DialogTitle  sx={{color:(theme === 'light')?"#19191B":"#FFFFFF", fontFamily:'Roboto',alignContent:"center",justifyContent:"left",textAlign:'left','&.MuiDialogTitle-root':{padding:'8px'}}}>
                    <Box sx={{display:'flex',flexDirection:"column", alignContent:"left",textAlign:'left',padding:"0px 12px "}}>
                      {"Project List"}
                      <Typography sx={{fontSize:"16px",marginBottom:"2px",color:'#005c8e'}}>{name}</Typography>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{alignContent:"center",padding:'24px','&.MuiDialogContent-root':{padding:'0px 20px'}}} >
                    <DialogContentText style={{alignContent:"center",textAlign:align? align: 'left'}} sx={{color:(theme === 'light')?"#19191B":"#FFFFFF",}}>
                      {"Select the projects to be associated with the device " + (level.level===0?"type": "subtype") + ". You can select multiple projects."}
                    </DialogContentText>
                    <Box sx={{display:'flex',flexDirection:'column',width:'100%',maxHeight:'400px',BoxSizing:"border-box",margin:"8px 0px"}}>
                        <Typography sx={{color:(theme === 'light')?"#19191B":"#FFFFFF",fontSize:"16px",padding:'8px 8px'}}>Projects</Typography>
                        <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                        <Box sx={{width:'100%',overflow:'auto'}}>
                            {data.map((value,index) => (
                              <>
                                <Box sx={{gap:'8px',display:'flex',flexDirection:'row',height:'100%',width:'100%',boxSizing:'border-box',padding:"8px",alignItems:'center',justifyContent:'start'}}>
                                      <CustomCheckbox id={index}  disabled={value.id===projectname?true:false} checked={selectedoption.includes(value.id)?true:false} onChange={handleCheck} width={15} height={15}/>
                                      <Typography sx={{color:(theme === 'light')?"#19191B":"#FFFFFF",fontSize:"16px"}}>{value.name}</Typography>
                                </Box>
                                <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                              </>
                            ))} 
                        </Box>
                    </Box>
                    <Box sx={{gap:'8px',display:'flex',flexDirection:'row',height:'100%',width:'100%',boxSizing:'border-box',margin:"32px 0px 8px 0px",alignItems:'center',justifyContent:'start'}}>
                            <CustomCheckbox id={'all'} checked={projectlist.includes('all')?true:false} disabled={selectedoption.includes('all')?true:false} onChange={handleCheck} width={15} height={15}/>
                            <Typography sx={{color:(theme === 'light')?"#19191B":"#FFFFFF",fontSize:"16px"}}>{"Apply for all projects in organization"}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{justifyContent:'left',padding:'8px 20px'}}> 
                  {<CustomButton onClick={handleSave} buttonText={"Save"} ></CustomButton>} 
                  {<CustomCancelButton onClick={handleClose} buttonText={"Cancel"} ></CustomCancelButton>} 
                </DialogActions>
            </Dialog> 
        </>
    )
}


export default function DeviceTypes() {

    const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      required: true,
      width: '30%',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: '50%',
      required: false,
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      width: '20%',
      key: 'operation',
      required: false,

    },
  ];

    const filter = ["Status Connected","Status Disconnected","State Enabled","State Disabled"];
    const filterMap = {connectionstate:"Status",enable:"State"};


    const{ theme }= useContext(ThemeContext);

    const [loading,setLoading]=useState(1);
    const [openForm, setOpenForm] = React.useState(0);
    const [required, setRequired] = React.useState(0);
    const [tableData, setTableData] = React.useState([]);
    const [editKey,setEditKey] = React.useState({key:'',level:0});
    const [saveStatus, setSaveStatus] =  React.useState(0);
    const [saveProjectStatus, setSaveProjectStatus] =  React.useState(0);
    const [search, setSearch] = useState({searchText:"",filterSelected:""});
    const [ifsearching, setifSearching] = useState(0);
    const [deleteConfimed, setDeleteConfirmed] = React.useState(0);
    const [deleteArr, setDeleteArr] = React.useState([[],[]]);
    const [checkAll, setCheckAll] = React.useState(false);
    const [deleteSuccess, setDeleteSuccess] = React.useState(0);
    const [searchList,setsearchList] = React.useState([]);
    const [projectlist ,setprojectlist ] = React.useState([]);
    const [allprojects ,setallprojects ] = React.useState([]);
    const [indexlevel ,setindexlevel] = React.useState({level:0,index:0,id:''});
    const [openprojectlist ,setopenprojectlist ] = React.useState(0);
    const [disableButtons,setDisableButtons] = useState(99);
        //for disableButtons = 0, all buttons are enabled
        //for disableButtons = 99, all buttons are disabled 
        //for disableButtons = 1, only delete button  and select all and close is enabled  ///search  what about search while deleting??
        //for disableButtons = 2, only save form and close form is enabled ?
    
    const userdetails = useSelector(state => state.logindata.userdetails);
    const projectname = useSelector(state => state.mainpagedata.selectedprojectname)
    const projectdata = useSelector(state => state.logindata.projectdata)

    useEffect(() => {
        getDevicesTypes(getDevicesTypesCallback)
        setallprojects([{name:projectdata[0].Projectname,id:projectdata[0].ProjectId}])
    },[])

    function getDevicesTypesCallback(res){
        if(res.status===200){
            if(res.data.data.length!==0){
              setTableData(res.data.data);
            }
        }else if(res.status===500){
            // pop for error
        }
        setLoading(0);
        setDisableButtons(0);

    }

    function handleSave(data) { 
        let temp = [...tableData]
        let type ={key:"",index:-1}
        if((data.key!==undefined && data.key!==null)){
          for (let i = 0; i < tableData.length; i++){
              // if(temp[i].children && temp[i].children.length!==0 && temp[i].operation==="subtype"){                   //// && temp[i].children.length!==0 
              //   handleSave(temp[i].children)
              // }
              if(temp[i].key===data.key){
                  // temp[i].name = data.name
                  // temp[i].description = data.description
                  type ={key:data.key,index:i}
                  // return temp;
                  break;
              } else{
                  for (let j = 0; j < temp[i].children.length; j++){
                    // if(temp[i].children && temp[i].children.length!==0 && temp[i].operation==="subtype"){                   //// && temp[i].children.length!==0 
                    //   handleSave(temp[i].children)
                    // }
                    if(temp[i].children[j].key===data.key){
                        // temp[i].children[j].name = data.name
                        // temp[i].children[j].description = data.description
                        type = {key:temp[i].key,index:i}
                        // return temp;
                        break
                      }
                  }

              }
              // else {return null}
          }
        }
        // return null;    
        saveDeviceTypes(data,type,saveDevicesTypesCallback)
        setEditKey({key:'',level:0})
        setLoading(1);
    };  

    function saveDevicesTypesCallback(res,data,type) { 
        let temp = [...tableData]
        let tempSearchList = [...searchList]
        if(res.status===200){
                if(res.data.type==='success'){
                  if(data.id===""){
                      if(data.operation==='type'){
                        temp[temp.length-1].id = res.data.data
                        temp[temp.length-1].key = res.data.data
                        temp[temp.length-1].name = data.name
                        temp[temp.length-1].description = data.description
                        // temp[temp.length-1].user = data.user
                        temp[temp.length-1].projectlist = data.projectlist
                        if(ifsearching===1){
                            tempSearchList[tempSearchList.length-1]={id:res.data.data,key:res.data.data,name:data.name,description:data.description,operation:data.operation,user:userdetails.username,projectlist:data.projectlist}
                            setsearchList(tempSearchList)
                        }
                      }else{ 
                        const len = temp[type.index].children.length
                        temp[type.index].children[len-1].id = res.data.data
                        temp[type.index].children[len-1].key = res.data.data
                        temp[type.index].children[len-1].name = data.name
                        temp[type.index].children[len-1].description = data.description
                        // temp[type.index].children.user = data.user
                        // temp[type.index].children.projectlist = data.lllprojectlist
                        if(ifsearching===1){
                            searchList.map((item,sindex)=>{
                                // if(item.id===temp[type.index].id){
                                //     tempSearchList[sindex].children[tempSearchList[sindex].children.length-1]={id:res.data.data,key:res.data.data,name:data.name,description:data.description,operation:data.operation,user:userdetails.username,projectlist:data.projectlist}
                                // }
                                if(item.id===temp[type.index].id){
                                    // item.children.map((citem,cindex)=>{
                                    // if(citem.id===temp[type.index].id){
                                        tempSearchList[sindex].children[tempSearchList[sindex].children.length-1]={id:res.data.data,key:res.data.data,name:data.name,description:data.description,operation:data.operation,user:userdetails.username,projectlist:data.projectlist}
                                    // }
                                // })
                                }
                            })
                            setsearchList(tempSearchList)
                        }
                      }
                  }else{
                      if(data.operation==='type'){
                        for (let i = 0; i < tableData.length; i++){
                            // if(temp[i].children && temp[i].children.length!==0 && temp[i].operation==="subtype"){                   //// && temp[i].children.length!==0 
                            //   handleSave(temp[i].children)
                            // }

                            if(temp[i].key===data.key){
                                temp[i].name = data.name
                                temp[i].description = data.description
                                // return temp;
                                break;
                            } 
                            // else {return null}
                        }
                        if(ifsearching===1){
                            searchList.map((val,index)=>{
                                if(val.key===data.key){
                                    tempSearchList[index].name = data.name
                                    tempSearchList[index].description = data.description
                                }
                            })
                            setsearchList(tempSearchList)
                        }
                      }
                      else{
                        for (let i = 0; i < tableData.length; i++){
                              // if(temp[i].children && temp[i].children.length!==0 && temp[i].operation==="subtype"){                   //// && temp[i].children.length!==0 
                              //   handleSave(temp[i].children)
                              // }
                             if(temp[i].children.length!==0 /*&& temp[i].operation==="subtype"*/){
                                  for (let j = 0; j < temp[i].children.length; j++){
                                    // if(temp[i].children && temp[i].children.length!==0 && temp[i].operation==="subtype"){                   //// && temp[i].children.length!==0 
                                    //   handleSave(temp[i].children)
                                    // }
                                    if(temp[i].children[j].key===data.key){
                                        temp[i].children[j].name = data.name
                                        temp[i].children[j].description = data.description
                                        // return temp;
                                        break
                                      }
                                  }

                              }
                              // else {return null}
                        } 
                        if(ifsearching===1){
                            searchList.map((val,index)=>{
                                if(val.children.length!==0){
                                    val.children.map((cval,cindex)=>{
                                        if(cval.key===data.key){
                                            tempSearchList[index].children[cindex].name = data.name
                                            tempSearchList[index].children[cindex].description = data.description
                                        }
                                    })
                                }
                            })
                            setsearchList(tempSearchList)
                        }
                      }
                  }
                  setTableData(temp)
                  setSaveStatus(1)
                }
        }else if(res.status===500){
            // pop for error
            setSaveStatus(0)
        }
        setLoading(0);
    };

    function handleProjectList(index,indexlevel1) { 
        setopenprojectlist(1)
        setprojectlist(index.projectlist)
        setindexlevel({index:indexlevel1.index,level:indexlevel1.level,id:index.id})
        // if(tableData.length < 256){
        //   let key = -1
        //   if(tableData.length!==0){
        //     key = (tableData[tableData.length-1].key)+1
        //   }
        //   setTableData([...tableData,{id:"",key: key,name:"",description:"",operation:"type",user:"",children:[],projectlist:[]}])
        //   setEditKey({key:key,level:0})
        // }
        // else{//mseage say exceeded max limit
        //   }
    };

    function handleSaveProject(list,id){
        let projectlist = [...list];
        let allproject = 0;
        if(projectlist.includes('all')){
            projectlist = projectlist.filter(value => value!=='all');
            allproject = 1;
        }
        saveDeviceTypeProjects(projectlist,allproject,indexlevel,saveDeviceTypeProjectsCallback)
    }

    function saveDeviceTypeProjectsCallback(res,projectlist,allproject){
        if(res.status===200){
            if(res.data.type==='success'){
                if(indexlevel.level===0){
                    if(allproject===1){
                        tableData[indexlevel.index].projectlist=['all',projectname,...projectlist]
                    }else{
                        tableData[indexlevel.index].projectlist=[...projectlist]
                    }
                }
                else{
                    for(let i = 0; i < tableData.length; i++){
                           for(let j =0; j < tableData[i].children.length;j++) {
                                if(tableData[i].children[j].id===indexlevel.id){
                                    if(allproject===1){
                                        tableData[i].children[j].projectlist=['all',projectname,...projectlist]
                                    }else{
                                        tableData[i].children[j].projectlist=[...projectlist]
                                    }
                                }
                           }
                        }
                }
                setopenprojectlist(0)
                setprojectlist([]); ///maybe refine this a bit
                setSaveProjectStatus(1)
            }
        } else if(res.status===500){
            // pop for error
            setSaveProjectStatus(2)
        }
    }
    
    function handleCloseProject(){
        setopenprojectlist(0)
        setprojectlist([]);
    }

    function handleAddType() { 
        if(tableData.length < 256){
          let key = -1
        //   if(tableData.length!==0){
        //     key = (tableData[tableData.length-1].key)+1
        //   }
          setTableData([...tableData,{id:"",key: key,name:"",description:"",operation:"type",user:"",children:[],projectlist:[projectname]}])
          setEditKey({key:key,level:0})
          if(ifsearching===1){
            setsearchList([...searchList,{id:"",key: key,name:"",description:"",operation:"type",user:"",children:[],projectlist:[projectname]}]);
          }
        }
        else{//mseage say exceeded max limit
          }
    };

    function handleAddSubType(index,level,pid) { 
        let stno = 0
        tableData.map((value)=>{
            stno = stno + value.children.length
        })
        if(stno < 256){
            let key = -1
            // if(tableData[index].children.length !== 0){
            //     key = (tableData[index].children[tableData[index].children.length-1].key)+1;
            // }
            let temp = [...tableData];
            for(let i = 0; i < tableData.length; i++){
                if(tableData[i].id===pid){
                    // key = (temp[i].children.length!==0)?(temp[i].children[temp[i].children.length-1].key)+1:-1;
                    temp[i].children.push({id:"",key: key,name:"",description:"",operation:"subtype",user:"",children:[],projectlist:[projectname]});
                    break;
                }
            }
            // temp[index].children.push({id:"",key: key,name:"",description:"",operation:"subtype",user:"",children:[]});
            // setTableData([...temp])
            if(ifsearching===1){
                let tempSearchList = [...searchList];
                searchList.map((value,index)=>{
                    if(value.id===pid){
                        tempSearchList[index].children.push({id:"",key: key,name:"",description:"",operation:"subtype",user:"",children:[],projectlist:[projectname]});
                    }
                })
                setsearchList([...tempSearchList]);
            }
            setEditKey({key:key,level:level+1})
        }
        else{
        //mseage say exceeded max limit
        }
    };

    function handleEditCancel(info) { 
        let temp = [...tableData];
        let i=[]
        let si = []
        if(info.id===""){
          if(info.operation==="type"){
              i = temp.filter((value) => value.key !== info.key);
            if(ifsearching===1){
                si = searchList.filter((value) => value.key !== info.key);
                setsearchList([...si])
            }
          }
          else{
                for (let k = 0; k < temp.length; k++){
                        temp[k].children = temp[k].children.filter((value) => value.key !== info.key);
                        i = [...temp];
                }
                if(ifsearching===1){
                    si = [...searchList]
                    for (let k = 0; k < searchList.length; k++){
                            si[k].children = searchList[k].children.filter((value) => value.key !== info.key);
                    }
                    setsearchList([...si])
                }
          }
          setTableData([...i]);
        }
    };

    function handleDeleteCancel(){
        // deleteGatewayArr.map((val)=>(
        //     deviceno.filter((value)=>value!==val)
        // ))
        setDeleteArr([[],[]]);
        // setDeleteDevice(0);
        setDeleteConfirmed(0);
        setDisableButtons(0);
        setCheckAll(false)
        //gatewaydelete(deleteGatewayArr,deletioncallback)
        
    }

    function handleDeleteConfirmed(){
            deleteDeviceType(deleteArr,deleteDeviceTypeCallback)
            setDeleteConfirmed(0)
            setLoading(1)
            // }
            // else{
            //     //popup plz select device
            // }       
    }

    function deleteDeviceTypeCallback(res){
        if(res.status===200){
            if(res.data.type==='success'){
                    let temp = [...tableData];
                    for (let k = 0; k < deleteArr[0].length; k++){
                        temp= temp.filter((value)=>value.key!==deleteArr[0][k])
                        // for(let i =0 ;i < temp.length; i++){
                        //     temp[i].children= temp[i].children.filter((value)=>value.key!==deleteArr[0][k])
                        // }

                        // for (let i = 0; i < tableData.length; i++){
                        //     if(temp[i].key===deleteArr[k].key){
                        //         temp[i].name = data.name
                        //         temp[i].description = data.description
                        //         // return temp;
                        //         break;
                        //     } else if(temp[i].children.length!==0 /*&& temp[i].operation==="subtype"*/){
                        //         for (let j = 0; j < temp[i].children.length; j++){
                        //           // if(temp[i].children && temp[i].children.length!==0 && temp[i].operation==="subtype"){                   //// && temp[i].children.length!==0 
                        //           //   handleSave(temp[i].children)
                        //           // }

                        //           if(temp[i].children[j].key===deleteArr[k].key){
                        //               temp[i].children[j].name = data.name
                        //               temp[i].children[j].description = data.description
                        //               // return temp;
                        //               break
                        //             }
                        //         }

                        //     }
                        //     // else {return null}
                        // }
                    }
                    for (let k = 0; k < deleteArr[1].length; k++){
                            // temp= temp.filter((value)=>value.key!==deleteArr[1][k])
                        for(let i =0 ;i < temp.length; i++){
                            temp[i].children= temp[i].children.filter((value)=>value.key!==deleteArr[1][k])
                        }
                    }
                    setTableData([...temp]);
                    setDeleteSuccess(1);
                    //devicedelete(deleteDeviceArr,userdetails.Organizationid,userdetails.Projectid,deletioncallback)
                    // if(deleteDeviceArr.length>0){
                    //     // devicedelete(deleteDeviceArr,deletioncallback) 
            }
        } else if(res.status===500){
            // pop for error
            setDeleteSuccess(2);
        }
        setDeleteArr([[],[]]);
        setDisableButtons(0);
        setCheckAll(false)
        setLoading(0)
    }

    function handleDeleteSelected(){
        // deleteDeviceArr.map((val)=>(
        //     deviceno.filter((value)=>value!==val)
        // ))
        if(deleteArr[0].length===0 && deleteArr[1].length===0){
            setDeleteConfirmed(2);
        }
        else{
            setDeleteConfirmed(1);
        }
    }

    function handleFilterSelected(selectedValue){
        search.filterSelected=selectedValue;
        setSearch(search);
    };

    function handleSearchText(selectedValue){
        search.searchText=selectedValue;
        setSearch(search);
    };

    function handleSearchCancel(){
        setSearch({searchText:"",filterSelected:""});
        setsearchList([]);
        setifSearching(0);
    };

    function handleSearchClick(){
        let temp = [];
        let templist = [...tableData];
        // if(search.filterSelected!==""){
        //     const filterVal=Object.entries(filterMap).find(([_key, value]) => search.filterSelected.includes(value));
        //     setifSearching(1);
        //     let val="";
        //     //("Enabled" || "Connected")
        //     if(search.filterSelected.includes("Enabled")){ 
        //         val=true;
        //     }else if(search.filterSelected.includes("Disabled")){
        //         val=false;
        //     }
        //     deviceno.filter(value => {
        //         if(search.filterSelected.includes("Connected") || search.filterSelected.includes("Disconnected")){
        //             connState.map(val => {
        //                 if(val[0]===value.id && search.filterSelected.includes(val[1])){
        //                     temp=[...temp,value];
        //                 }
        //             })
        //         }
        //         else{
        //             Object.keys(value.data).forEach(key => {
        //                 if (key === filterVal[0] ) {
        //                     if(value.data[key] === val || value.data[key] === val.toString())
        //                         {
        //                             temp=[...temp,value];
        //                         }
        //                 }
        //             });
        //         }
        //         templist=[...temp];
        //     })
        // }
        if(search.searchText!==""){
        setifSearching(1);
        temp = [];
        templist.map((value,index)=>{
            if(value.description.toLowerCase().includes(search.searchText.toLowerCase()) || value.name.toLowerCase().includes(search.searchText.toLowerCase())){
                // let val = value;
                // val.children = [];
                temp=[...temp,{...value,children:[]}];
            }
            if(value.children && value.children.length!==0){
                value.children.map(child=>{
                    if(child.description.toLowerCase().includes(search.searchText.toLowerCase()) || child.name.toLowerCase().includes(search.searchText.toLowerCase())){
                        if(temp.length!==0){
                            if(temp[temp.length-1].key===value.key){
                                temp[temp.length-1].children=[...temp[temp.length-1].children,child];
                            }
                            else{
                                temp=[...temp,{...value,children:[child]}];
                            }
                        }
                        else{
                            temp=[...temp,{...value,children:[child]}]
                        }
                    }
                })
            }
        })
        }
        setsearchList(temp);
    };

    function handleCheck(selected,e,level){
        let ids = [[],[]]
        if(level===0){
            ids[0]=[...ids[0],e.target.id]
            let temptype = tableData.filter((value) => value.id === e.target.id);
            temptype[0].children.map((value)=>{
                let dupli = deleteArr[1].filter((val) => val === value.id);
                if(dupli.length===0){
                    ids[1]=[...ids[1],value.id]  /// if no duplicate then only add to ids[1]
                }
            })
        }else{
            ids[1]=[...ids[1],e.target.id]
        }
        if(selected===true){
          setDeleteArr([[...deleteArr[0],...ids[0]],[...deleteArr[1],...ids[1]]]);
          setDisableButtons(1);
        }else if(selected===false){
          let temp = [[...deleteArr[0]],[...deleteArr[1]]]
          if(level===0){
            for(let i = 0; i < ids[0].length; i++){
                let temptype = tableData.filter((value) => value.id === e.target.id);
                temp[0] = temp[0].filter(value => value!==ids[0][i]);
                temptype[0].children.map((val)=>{
                    temp[1] = temp[1].filter(value => value!==val.id);
                })
            }
          }else{
            for(let i = 0; i < ids[1].length; i++){
                temp[1] = temp[1].filter(value => value!==ids[1][i]);
            }
          }
          setDeleteArr([...temp]);
          if(temp.length===0){
            setDisableButtons(0);
          }
        }
        // deleteGatewayArr.map((val)=>(
        //     deviceno.filter((value)=>value!==val)
        // ))
        // setDeleteDeviceArr([]);
        // setDeleteDevice(0);
        // setDeleteConfirmed(0);
        //gatewaydelete(deleteGatewayArr,deletioncallback)
    }

    function handleCheckALL(selected,e,level){
        if(selected===true){
            let temp = [[],[]];
            tableData.map((value,index)=>{
                const ifstd = value.name.charAt(0)==='_'?true:false;
                if(ifstd!==true){
                    temp[0]=[...temp[0],value.key];
                }
                if(value.children && value.children.length!==0){
                    value.children.map(child=>{
                         const ifstdc = child.name.charAt(0)==='_'?true:false;
                        if(ifstdc!==true){
                            temp[1]=[...temp[1],child.key];
                        }
                    })
                }
            })
          setDeleteArr([...temp]);
          setDisableButtons(1);
          setCheckAll(true)
        }else if(selected===false){
          setDeleteArr([[],[]]);
          setDisableButtons(0);
          setCheckAll(false)
        }
        // deleteGatewayArr.map((val)=>(
        //     deviceno.filter((value)=>value!==val)
        // ))
        // setDeleteDeviceArr([]);
        // setDeleteDevice(0);
        // setDeleteConfirmed(0);
        //gatewaydelete(deleteGatewayArr,deletioncallback)
        
    }
    
    function handleToastClose(){
        setSaveStatus(0)
    }

    function handleProjectToastClose(){
        setSaveProjectStatus(0)
    }


    function  handleDeleteToastClose(){
        setDeleteSuccess(0)
    }

    function handleDisable(val){
        setDisableButtons(val);
    }

    function handleTypeSubTypeName(){
        let name = "";
        if(indexlevel.level===0 && tableData.length!==0){
            name = tableData[indexlevel.index].name;
        }else{
            for(let i = 0; i < tableData.length; i++){
                if(tableData[i].children.length>indexlevel.index){
                    if(tableData[i].children[indexlevel.index].id===indexlevel.id){
                        name = tableData[i].children[indexlevel.index].name;
                        break;
                    }
                }
            }
        }
        return name;
    }

    return (
        <Box className="compliance-config" sx={{height :"100%",boxSizing:"border-box",width:'100%'}}>
                    <Box  sx={{padding:"0px",height:'calc(100% - 0px)',width:"100%" ,boxSizing:"border-box"}} >
                        <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                        {saveStatus!==0?<CustomToast openToast={saveStatus!==0} /*type={ saveStatus===1?"Success":"Error"}*/ autoHideDuration={10000} toastText={saveStatus===1?"Saved Successfully!":"Save Failed"} onClose={handleToastClose}/>:<></>}
                        {saveProjectStatus!==0?<CustomToast openToast={saveProjectStatus!==0} /*type={ saveProjectStatus===1?"Success":"Error"}*/ autoHideDuration={10000} toastText={saveProjectStatus===1?"Saved Successfully!":"Save Failed"} onClose={handleProjectToastClose}/>:<></>}
                        {deleteSuccess!==0?<CustomToast openToast={deleteSuccess!==0} /*type={deleteSuccess===1?"Success":"Error"}*/ toastText={deleteSuccess===1?"Deleted Successfully!":"Delete Failed"} onClose={handleDeleteToastClose}/>:<></>}
                        {openForm===0?
                            <>
                                <Box  sx={{display:'flex', flexDirection:'row',width:'100%',fontSize:"16px",fontFamily:"Roboto",margin:"0px",alignSelf:"center" }}>
                                    <Typography sx={{textAlign:'left',color:'var(--PrimaryText)',alignContent:'end'}}>Only Custom device types can be selected and modified.</Typography>
                                </Box>
                                <Box sx={{flexGrow:1,height:'24px',alignSelf:"center"}}></Box> 
                                <CustomTooltip title={"Add"} offset={[30,-20]} placement={'right-end'}>
                                    <Button onClick={handleAddType} disabled={disableButtons!==0?true:false} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'40px',minWidth:'28px',fontWeight: 400,alignSelf:"center",marginLeft:"auto",marginRight:"auto",marginTop:'-8px'}}><LK_Add color={disableButtons!==0?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"28px"} height={"28px"}/></Button>
                                </CustomTooltip>
                                <CustomTooltip title={"Delete"} offset={[30,-20]} placement={'right-end'}>
                                    <Button onClick={handleDeleteSelected} disabled={(disableButtons!==0 && disableButtons!==1)?true:false} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'36px',width:'36px',minWidth:'36px',boxSizing:'border-box', fontWeight: 400,alignSelf:"center",marginLeft:"-4px",marginRight:"0",marginTop:'-8px'}}><LK_Delete color={(disableButtons!==0 && disableButtons!==1)?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"36px"} height={"36px"}/></Button>
                                </CustomTooltip>
                                <CustomDialogBox dialogTitle={"Delete Confirmation"} dialogText={"Are you sure you want to delete "+ (deleteArr[0].length + deleteArr[1].length) + " device types/subtypes. Note: The deletion will be for the current project only." } openDialog={deleteConfimed===1} handleCloseDialog={handleDeleteCancel} handleConfirmDialog={handleDeleteConfirmed} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                                <CustomDialogBox dialogTitle={"Delete Confirmation"} dialogText={"Please select  type for deletion"} openDialog={deleteConfimed===2} handleCloseDialog={handleDeleteCancel} handleConfirmDialog={()=>{setDeleteConfirmed(0); setCheckAll(false);}} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                                <Box sx={{display:'flex', flexDirection:'row',fontSize:"16px",fontFamily:"Roboto",marginTop:"-4px",alignSelf:"center" ,gap:"8px", alignItems:"center"}}>
                                    <CustomTextField id={'negative-feedback'} onChange={handleSearchText} disabled={((disableButtons!==0 && disableButtons!==1))?true:false} defaultValue={ifsearching===0?"":search.searchText}  placeholder={"search"} width={180}/> 
                                    {/* <CustomDropDown options={filter} onChange={handleFilterSelected} disabled={((disableButtons!==0 && disableButtons!==1))?true:false} defaultValue={ifsearching===0?"":search.searchText} width={"180px"}></CustomDropDown>    */}
                                    <CustomTooltip title={"Search"} offset={[30,-20]} placement={'right-end'}>
                                        <Button onClick={handleSearchClick} style={{ fontSize: '12px',width:"40px", minWidth:"40px",fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"0px",padding:0}}><LK_Search color={((disableButtons!==0 && disableButtons!==1))?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"28px"} height={"28px"}/></Button> 
                                    </CustomTooltip>
                                    {ifsearching===1?<Button onClick={handleSearchCancel} style={{ fontSize: '12px',width:"34px",minWidth:"34px", fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"-8px",padding:0}}><LK_Close color={((disableButtons!==0 && disableButtons!==1))?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--HighlightedText_Stroke)'} width={"24px"} height={"24px"}/></Button>:<></> }
                                </Box>
                            </>
                            :
                            <>
                                <Box sx={{display:"flex",gap:'8px',width:'100%',height:"100%"}}>
                                    <Box sx={{flexGrow:1}}></Box>
                                    <CustomDialogBox dialogTitle={"Required fields not filled"} dialogText={"Required fields to must be filled"} openDialog={required===1} handleCloseDialog={()=>setRequired(0)} handleConfirmDialog={()=>setRequired(0)} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                                    <CustomDialogBox dialogTitle={"Device name already in use"} dialogText={"This device name is already in use"} openDialog={required===2} handleCloseDialog={()=>setRequired(0)} handleConfirmDialog={()=>setRequired(0)} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                                    {/* <CustomCancelButton onClick={handleCloseAddForm} buttonText={'Cancel'}></CustomCancelButton> */}
                                    {/* <CustomButton /*id={deviceInfo.id}* onClick={handleSaveAddForm} buttonText={'Save'} width={'12px'} /> */}
                                </Box>
                            </>
                        }
                        </Box>
                        <Box sx={{boxSizing:"border-box",padding:"8px",background:'var(--PrimaryBackground)',height:'calc(93%)',marginBottom:"0px",overflow:"auto"}}>
                        {loading===0?
                            <>
                                {/* {openForm===0?
                                    <>
                                        <Box sx={{display:"flex",gap:'8px',flexWrap:'wrap',boxSizing:"border-box",height:'calc(100%)',overflow:"auto",alignContent:"flex-start"}} >
                                           <EditableAccordionTable/>
                                        </Box>
                                    </>
                                :
                                    <Box sx={{display:"flex",gap:'8px',flexWrap:'wrap',height:'100%',boxSizing:"border-box"}} >
                                    </Box>
                                } */}
                                <Box sx={{height:"100%",width:"100%",backgroundColor:"var(--SecondaryBackground)",boxSizing:"border-box",padding:"8px",}}>
                                    <Box sx={{height:"8%",width:"100%",backgroundColor:"none",boxSizing:"border-box",display:'flex',flexDirection:'row'}}>
                                        {/* <Box sx={{height:'100%',boxSizing:"border-box",padding:"8px",display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                            <CustomCheckbox defaultChecked={false} onChange={handleCheck} width={15} height={15}/>
                                        </Box> */}
                                        {columns.map((column,index) => (
                                            <>
                                            <Box sx={{height:'100%',width:column.width?column.width:'auto',backgroundColor:"none",boxSizing:"border-box",padding:"8px",alignContent:"center",display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start'   }}>
                                                {index===0?
                                                    <Box sx={{height:'100%',boxSizing:"border-box",padding:"8px 8px 8px 0px",display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                        <CustomCheckbox id={column.id} checked={checkAll} disabled={disableButtons!==0 && disableButtons!==1?true:false} onChange={handleCheckALL} width={15} height={15}/>
                                                    </Box>
                                                :<></>
                                                }
                                                <Typography sx={{textAlign:'left',color:'var(--PrimaryText)',alignContent:'end'}}>{column.title}</Typography>
                                            </Box>
                                            </>
                                        ))}
                                    </Box>
                                    <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                                    <Box sx={{height:"92%",width:"100%",backgroundColor:"none",boxSizing:"border-box",display:'flex',flexDirection:'column',overflow:"auto",alignItems:'center'}}>
                                        <ProjectForm openDialog={openprojectlist===1?true:false} handleCloseDialog={handleCloseProject} handleConfirmDialog={handleSaveProject} data={allprojects} selectedoption={projectlist} level={indexlevel} name={handleTypeSubTypeName()}/>
                                        <TableRow width={"100%"} data={ifsearching===1?searchList:tableData} columns={columns} disableButtons={disableButtons} handleCheck={handleCheck} handleSave={handleSave} editKey={editKey} editCancel={handleEditCancel} addSubType={handleAddSubType} level={0} checkList={deleteArr} handleProjectList={handleProjectList} handleDisable={handleDisable} disabled={disableButtons}/>
                                    </Box>
                                </Box>
                            </> 
                            :
                            <Box sx={{gap:'8px',boxSizing:"border-box",height:'calc(100%)',width:'100%',overflow:"auto",alignContent:"center"}} >
                                <img src={LK_Loading} alt="loading..." style={{height:"15%" ,width:"auto",alignSelf:"center"}} />
                            </Box>
                        }
                        </Box>
                    </Box>
                </Box>
    )
}